<main class="container">
  <div class="center-content">
    <div class="row">
      <h1>Sorry, an error occurred processing your request.</h1>
    </div>
  </div>
</main>
